import type { InkDocumentV1 } from '../../types/ink';

type Props = { document: InkDocumentV1; height?: number };

export function InkPreview({ document, height = 110 }: Props) {
  const paths = document.strokes.map((stroke) => ({
    id: stroke.id,
    d: stroke.points.map((point, index) => {
      const x = point.x <= 1 ? point.x * document.width : point.x;
      const y = point.y <= 1 ? point.y * document.height : point.y;
      return `${index === 0 ? 'M' : 'L'} ${x} ${y}`;
    }).join(' '),
  }));
  return (
    <svg className="ink-preview" viewBox={`0 0 ${document.width} ${document.height}`} style={{ height }} role="img" aria-label="Tulisan siswa yang tersimpan">
      <rect x="0" y="0" width={document.width} height={document.height} className="ink-pad__paper" />
      {paths.map((path) => <path key={path.id} d={path.d} className="ink-pad__stroke" vectorEffect="non-scaling-stroke" />)}
    </svg>
  );
}
